import React from 'react';

import * as S from './Rating.styles';

import Text from '../../../../../core-components/TextFieldExpt/TextFieldExpt';
import TripAdvisorIcon from '../../../../../Icons/TripAdvisorIcon';

// reviewCount, reviewType
function Rating({item}) {
  return (
    <>
      {item.xtr && item.xtr.g_rtg && (
        <S.Rating rating={item.xtr.g_rtg}>
          {item.xtr && item.xtr.gri === 3 && (
            // 🐨 use <Image /> component when its ready
            // <S.tripadvisorImageStyles
            //   src="https://gos3.ibcdn.com/trip_adviser-1557838494.png"
            //   alt="Trip Advisor Logo"
            // />
            <TripAdvisorIcon />
          )}
          <Text inline>{item.xtr.g_rtg} / 5</Text>
        </S.Rating>
      )}
    </>
  );
}

export default Rating;
